'use strict';

angular.module('nfseApp').controller('GuiaDialogController',
    ['$scope', '$stateParams', '$modalInstance', 'entity', 'Guia', 'DeclaracaoMensalServico',
        function($scope, $stateParams, $modalInstance, entity, Guia, DeclaracaoMensalServico) {

        $scope.guia = entity;
        $scope.declaracaomensalservicos = DeclaracaoMensalServico.query();
        $scope.load = function(id) {
            Guia.get({id : id}, function(result) {
                $scope.guia = result;
            });
        };

        var onSaveFinished = function (result) {
            $scope.$emit('nfseApp:guiaUpdate', result);
            $modalInstance.close(result);
        };

        $scope.save = function () {
            if ($scope.guia.id != null) {
                Guia.update($scope.guia, onSaveFinished);
            } else {
                Guia.save($scope.guia, onSaveFinished);
            }
        };

        $scope.clear = function() {
            $modalInstance.dismiss('cancel');
        };
}]);
